<div class="full main-content">
  <div class="full registration-confirmation-container">
    <div class="row">
      <div class="small-12 columns">
        <h1>
          Thanks for signing up!
        </h1>
        <p class="reg-confirmation-top-copy">
          Before you can access your account, we just need to make sure you’re a warm body, and not some sinister web
          bot.
        </p>

        <div id="registration-confirmation-list">
          <p>Please complete the following steps:</p>
          <ol>
            <li>Check your email</li>
            <li>Click on the confirmation link</li>
            <li>Get going!</li>
          </ol>
          <p>
            If you don’t see the confirmation email, please contact our warm-bodied people at <a
              href="mailto:admin@pakmatti.com">admin&#64;pakmatti.com</a>. We’ll be more than happy to
            help you out (unless you’re a sinister web bot)!
          </p>
          <p>
            Thank you!
          </p>
          <p><em>The pakmatti.com Team</em></p>
        </div>
      </div>
    </div>
  </div>
</div>
